<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="14">
          <span>
            <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-plus" @click="handleDetailCreate">添加到账</el-button>
          </span>
          &nbsp;
          <template v-if="is_completed && showConfirm">
          <span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleConfirm">完成到账确认</el-button>
          </span>
          &nbsp;
          </template>
          <span>
            <el-button type="primary" size="small" icon="el-icon-back" @click="goBack">返回</el-button>
          </span>
        </el-col>
      </el-row>

      <table width=100%>
        <tr width=100%>
          <th width=20%>文件名称</th>
          <th width=15%>保险公司</th>
          <th width=15%>所属分公司</th>
          <th width=5%>保费总额</th>
          <th width=5%>手续费总额</th>
          <th width=5%>详单数量</th>
          <th width=5%>开始日期</th>
          <th width=5%>结束日期</th>
          <th width=15%>备注</th>
        </tr>
        <tr>
          <td >{{billingFile.title}}</td>
          <td >{{billingFile.company}}</td>
          <td >{{billingFile.branch_office_name}}</td>
          <td >{{billingFile.total_premium}}</td>
          <td >{{billingFile.adjust_commission}}</td>
          <td >{{billingFile.total_details}}</td>
          <td >{{billingFile.start_time | parseTime('{y}-{m}-{d}')}}</td>
          <td >{{billingFile.end_time | parseTime('{y}-{m}-{d}')}}</td>
          <td >{{billingFile.remark}}</td>
        </tr>
      </table>
      <hr>

      <table width=100%>
        <tr>
          <th width=10%>应收金额</th>
          <th width=10% >未到账金额</th>
          <th width=10% >已到账金额</th>
          <th></th>
        </tr>
        <tr>
          <td>{{billingFile.adjust_commission}}</td>
          <td>{{unreceived_amount}}</td>
          <td>{{received_amount}}</td>
          <td></td>
        </tr>
      </table>
      <hr>

      <!-- 账单文件列表 -->
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                fit highlight-current-row class="w-100">
        <!-- id -->
        <el-table-column align="left" label="id" width="50">
          <template slot-scope="scope">
            <span v-if="showView"
              >{{scope.row.id}}</span>
          </template>
        </el-table-column>

        <!-- 收款账户 -->
        <el-table-column align="left" label="收款账户">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.received_account}}</span>
          </template>
        </el-table-column>

        <!-- 收款金额 -->
        <el-table-column align="left" label="收款金额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.amount| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 收款日期 -->
        <el-table-column align="left" label="收款日期" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.received_date | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark}}</span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column align="left" label="操作" width="150px">
          <template slot-scope="scope">

            <el-tooltip effect="light" placement="top-start" content="编辑">
              <el-button v-if="showEdit" type="text"
                @click="handleUpdate(scope.row.id, showDialogSave)" >
                <i class="el-icon-edit"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="删除">
              <el-button v-if="showDelete" type="text"
                @click="handleDelete(scope.row.id)" >
                <i class="el-icon-delete"></i>
              </el-button>
            </el-tooltip>

          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <pagination :size.sync="query.limit" :offset.sync="query.offset" :total="total" ></pagination>
    <received-detail-dialog ref="detail"
      :billing_file_id="billing_file_id"
      :adjust_commission="adjust_commission"
      :received_amount="received_amount"
      :unreceived_amount="unreceived_amount" >
    </received-detail-dialog>

  </div>
</template>

<script>
  import { confirmRecordsFieldStatus } from '@/api/billing'
  import { deleteReceived } from '@/api/billing'
  import { fetchBillingFile } from '@/api/billing'
  import { fetchReceivedList } from '@/api/billing'
  import { parseTime } from '@/utils'
  import { EventBus } from "@/utils/event-bus"
  import { formatCurrency } from '@/utils/misc'
  import Pagination from '@/components/Pagination'
  import ReceivedDetailDialog from './received-detail-dialog'

  export default {
    name: "received-list",
    components: {
      Pagination,
      ReceivedDetailDialog
    },

    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },
    },

    data() {
      return {
        showView: false,
        showAdd: false,
        showEdit: false,
        showDelete: false,
        showConfirm: false,
        showDialogSave: true,
        company: '',
        searching: false,
        loading: false,
        loadingText: '正在加载数据，请稍等...',
        query: {
          search: '',
          offset: 0,
          limit: 20
        },
        total: 0,
        list: [],
        billingFile:[],
        adjust_commission: 0.0
      }
    },

    computed:{
      received_amount: function() {
        let result = 0.0
        for (let l of this.list) {
          result = result + parseFloat(l.amount)
        }
        return parseFloat(result.toFixed(4))
      },
      unreceived_amount: function() {
        let result = 0.0
        result = this.billingFile.adjust_commission - this.received_amount
        return parseFloat(result.toFixed(4))
      },
      is_completed: function() {
        let result = false
        if (this.billingFile.adjust_commission === this.received_amount && parseFloat(this.unreceived_amount) === 0.0){
          result = true
        }
        return result
      }
    },

    methods: {
      getList() {
        this.loading = true
        let p = []
        p.push(fetchBillingFile(this.billing_file_id))
        p.push(fetchReceivedList(this.billing_file_id))
        Promise.all(p)
          .then(res => {
            this.billingFile = res[0]
            this.adjust_commission = this.billingFile.adjust_commission
            this.list = res[1]
            this.loading = false
            if (this.billingFile.is_collected === 1){
              this.showAdd = false
              this.showConfirm = false
              // this.showEdit = false
              this.showDelete = false
              this.showDialogSave = false
            }
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      goBack() {
        this.$router.go(-1)
      },
      handleDetailCreate() {
        this.$refs.detail.handleCreate()
      },
      handleConfirm() {
        this.$confirm('确认后将完成收款确认,完成后该对账文件和相应的保单信息将不允许修改以及删除, 是否继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          confirmRecordsFieldStatus('collected', this.company, this.billing_file_id)
            .then(() => {
              this.$message.success('更新账单信息成功')
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '收入确认成功!'
                });
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消收款确认'
          });
        });
      },
      handleUpdate(id, showDialogSave) {
        this.$refs.detail.handleUpdate(id, showDialogSave)
      },
      handleDelete(id){
        this.$confirm('是否确认删除该笔收入继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          deleteReceived(this.billing_file_id, id)
            .then(() => {
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              setTimeout(() => {
                this.getList()
              }, 1000)
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        }).catch((e) => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
      },
    },

    created() {
      // 入参处理
      if (this.$route.query.billing_model === undefined || this.$route.query.billing_file_id === undefined){
        this.$router.push('/404')
      }
      this.company = this.$route.query.billing_model
      this.billing_file_id = this.$route.query.billing_file_id

      // 权限检查
      if (!this.$perm(["billing.list_received"])) {
        this.$router.push('/401')
      }
      this.showView = true

      if (this.$perm(["billing.create_received"])) {
        this.showAdd = true
      }

      if (this.$perm(["billing.confirm_received"])) {
        this.showConfirm = true
      }

      if (this.$perm(["billing.update_received"])) {
        this.showEdit = true
      }

      if (this.$perm(["billing.delete_received"])) {
        this.showDelete = true
      }

      EventBus.$on('created-received', () => {
        setTimeout(() => {
          this.getList()
        }, 1000)
      })

      EventBus.$on('updated-received', () => {
        setTimeout(() => {
          this.getList()
        }, 2000)
      })

      this.getList()
    },

  }
</script>
